import { useEffect } from "react";

const SITE = "https://stillwatermag.eu";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo({ title, description, canonical, jsonLd, ogType = "website" }) {
  useEffect(() => {
    if (title) document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", ogType);
    upsertMeta("property", "og:url", canonical);
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (canonical) {
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.href = canonical;
    }

    const existing = document.getElementById("sw-route-jsonld");
    if (existing) existing.remove();
    if (jsonLd) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "sw-route-jsonld";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
  }, [title, description, canonical, ogType, JSON.stringify(jsonLd)]);

  return null;
}

export const productJsonLd = (p, path) => {
  if (!p) return null;
  return {
    "@context": "https://schema.org",
    "@type": "Product",
    name: p.name,
    sku: p.sku,
    description: p.short_description || p.description || "",
    image: p.images?.[0] ? `${SITE}${p.images[0]}` : undefined,
    brand: { "@type": "Brand", name: p.brand || p.manufacturer },
    offers: {
      "@type": "Offer",
      url: `${SITE}${path}`,
      priceCurrency: p.currency || "EUR",
      price: p.price,
      availability: p.sold || !p.in_stock
        ? "https://schema.org/SoldOut"
        : "https://schema.org/InStock",
      itemCondition:
        p.product_type === "archive" ? "https://schema.org/UsedCondition" : undefined,
    },
  };
};

export const siteUrl = SITE;
